<template>
  <v-row no-gutters>
    <v-col cols="12">
      <field-group
        v-model="dialog.data.name"
        autofocus
        :error-messages="dialog.error.name"
        filled
        label="Tên"
        no-label
      />
    </v-col>

    <v-col cols="12">
      <field-group
        :value="dialog.data.type"
        filled
        label="Loại"
        no-label
        readonly
      />
    </v-col>

    <v-col cols="12">
      <field-group
        v-model="dialog.data.meta.field_name"
        :items="fieldsSelect"
        label="Trường hiển thị"
        no-label
        filled
        item-text="name"
        item-value="code"
        :error-messages="dialog.error['meta.field_name']"
        typeInput="v-select"
        @change="onChangeParams"
      />
    </v-col>

    <v-col cols="12">
      <field-group
        :value="dialog.data.meta.srid"
        filled
        :label="$t('layer.projection')"
        no-label
        readonly
      />
    </v-col>

    <v-col cols="12">Vùng bao Hệ toạ độ 4326</v-col>

    <v-col cols="5">
      <field-group
        v-model="dialog.data.meta.bbox_4326[0]"
        :error-messages="dialog.error['meta.bbox_4326.0']"
        filled
        label="Min X"
        no-label
        type="number"
      />
    </v-col>

    <v-col cols="2"></v-col>

    <v-col cols="5">
      <field-group
        v-model="dialog.data.meta.bbox_4326[1]"
        :error-messages="dialog.error['meta.bbox_4326.1']"
        filled
        label="Min Y"
        no-label
        type="number"
      />
    </v-col>

    <v-col cols="5">
      <field-group
        v-model="dialog.data.meta.bbox_4326[2]"
        :error-messages="dialog.error['meta.bbox_4326.2']"
        filled
        label="Max X"
        no-label
        type="number"
      />
    </v-col>

    <v-col cols="2"></v-col>

    <v-col cols="5">
      <field-group
        v-model="dialog.data.meta.bbox_4326[3]"
        :error-messages="dialog.error['meta.bbox_4326.3']"
        filled
        label="Max Y"
        no-label
        type="number"
      />
    </v-col>

    <v-col cols="12">
      <field-group
        :value="features_count"
        filled
        label="Số lượng đối tượng"
        no-label
        readonly
      />
    </v-col>

    <v-col cols="12">
      <field-group
        :value="fields.length"
        filled
        label="Số lượng trường dữ liệu"
        no-label
        readonly
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    features_count: {
      type: Number,
      required: true,
    },
  },
  computed: {
    fieldsSelect() {
      return this.fields.filter(
        (x) => !['region-field', 'geometry'].includes(x.type)
      )
    },
  },
  methods: {
    onChangeParams(fieldName) {
      this.$set(this.dialog.data.meta, 'field_name', fieldName)
    },
  },
}
</script>
